'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'circle-check';
var width = 512;
var height = 512;
var aliases = [61533,"check-circle"];
var unicode = 'f058';
var svgPathData = ['M16 256a240 240 0 1 0 480 0 240 240 0 1 0 -480 0zm130.3 18.3c3.1-3.1 8.2-3.1 11.3 0L223 339.7 353.4 160.4c2.6-3.6 7.6-4.3 11.2-1.8s4.4 7.6 1.8 11.2L230.5 356.7c-1.4 1.9-3.5 3.1-5.8 3.3s-4.6-.7-6.3-2.3l-72-72c-3.1-3.1-3.1-8.2 0-11.3z', 'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-496a240 240 0 1 0 0 480 240 240 0 1 0 0-480zm97.4 144.4c2.6-3.6 7.6-4.3 11.2-1.8s4.4 7.6 1.8 11.2L230.5 356.7c-1.4 1.9-3.5 3.1-5.8 3.3s-4.6-.7-6.3-2.3l-72-72c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L223 339.7 353.4 160.4z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;